import autocomplete from 'jquery-ui/ui/widgets/autocomplete';

document.addEventListener("DOMContentLoaded", function () {
  const containers = document.querySelectorAll(".js-minerva-form-autocomplete");
  // Add events to all containers with the class js-minerva-form-autocomplete
  containers.forEach( container => {
    const scriptTag = container.querySelector("script[type='application/json']");
    const input = container.querySelector("input");
    const resultsContainer = container.querySelector("#autocomplete-results");

    const data = JSON.parse(scriptTag.textContent);
    let selectedFromList = false;

    input.addEventListener("input", () => {
      const query = input.value.toLowerCase().trim();
      resultsContainer.innerHTML = "";
      resultsContainer.classList.add("hidden");
      selectedFromList = false;

      if (query.length === 0) return;

      const matches = data.filter((item) =>
        item.toLowerCase().includes(query)
      );

      if (matches.length === 0) return;

      matches.forEach((match) => {
        const li = document.createElement("li");
        li.className = "ui-menu-item px-4 py-2 hover:bg-yellow-100 cursor-pointer transition-colors duration-150";
        li.textContent = match;
        li.addEventListener("click", () => {
          input.value = match;
          selectedFromList = true;
          resultsContainer.classList.add("hidden");
        });
        resultsContainer.appendChild(li);
      });

      resultsContainer.classList.remove("hidden");
    });

    input.addEventListener("blur", () => {
      setTimeout(() => {
        const inputValue = input.value.trim().toLowerCase();
        const isValid = data.some(item => item.toLowerCase() === inputValue);

        if (!isValid) {
          input.value = "";
        }
        resultsContainer.classList.add("hidden");
      }, 180); // Small delay to allow click events to register
    });

    document.addEventListener("click", (e) => {
      if (!container.contains(e.target)) {
        resultsContainer.classList.add("hidden");
      }
    });
  });

  // Select dropdowns (with freetext)
  const selectContainers = document.querySelectorAll("select.js-minerva-form-select");
  selectContainers.forEach(select => {
    const wrapper = select.closest(".js-minerva-form-select-wrapper");
    const freetextContainer = wrapper.querySelector(".js-minerva-form-select-freetext");
    const freetextInput = wrapper.querySelector(".js-minerva-form-select-freetext-content");

    select.addEventListener("change", () => {
      const option = select.options[select.selectedIndex];
      if (option && option.hasAttribute("data-freetext")) {
        freetextContainer.classList.remove("hidden");
      } else {
        freetextContainer.classList.add("hidden");
      }
    });

    freetextInput.addEventListener("change", () => {
      const freetextOption = wrapper.querySelector("option[data-freetext]");
      if (freetextOption) {
        freetextOption.value = freetextInput.value;
      }
    });
  });

  // Password validation
  const passwordValidationContainer = document.querySelector(".js-minerva-form-password-validation-wrapper");
  const passwordInput = document.querySelector('input[type="password"]');
  const minLength = 6;

  passwordInput.addEventListener("input", () => {
    const value = passwordInput.value;
    const hasLetter = /[a-zA-Z]/.test(value);
    const hasNumber = /\d/.test(value);
    const isLongEnough = value.length >= minLength;
    const validationErrors = [];

    if (!isLongEnough && hasLetter && hasNumber) {
      validationErrors.push("Password must be at least 6 characters long.");
    } else if (!hasLetter && isLongEnough && hasNumber) {
      validationErrors.push("Password must include at least one letter.");
    } else if (!hasNumber && isLongEnough && hasLetter) {
      validationErrors.push("Password must include at least one number.");
    } else if (!isLongEnough && !hasLetter && hasNumber) {
      validationErrors.push("Password must be at least 6 characters long and include at least one letter.");
    } else if (!isLongEnough && hasLetter && !hasNumber) {
      validationErrors.push("Password must be at least 6 characters long and include at least one number.");
    } else if (isLongEnough && !hasLetter && !hasNumber) {
      validationErrors.push("Password must include at least one letter and one number.");
    } else if (!isLongEnough && !hasLetter && !hasNumber) {
      validationErrors.push("Password must be at least 6 characters long and include at least one letter and one number.");
    }

    // Clear old messages
    passwordValidationContainer.innerHTML = "";

    if (validationErrors.length > 0) {
      const errorList = document.createElement("ul");
      validationErrors.forEach(error => {
        const li = document.createElement("li");
        li.textContent = error;
        li.className = "text-red-500";
        errorList.appendChild(li);
      });
      passwordValidationContainer.appendChild(errorList);
      passwordValidationContainer.classList.remove("hidden");
    } else {
      passwordValidationContainer.classList.add("hidden");
    }
  });

  // Display source specify
  const displaySource = function(e) {
    const source = $("#id_source").val();
    if(source === "Other") {
      $(".source-other").slideDown();
    } else {
      $(".source-other").slideUp();
    }
  };
  displaySource();
  $("#id_source").change(displaySource);

  // Alternative address display
  const alternativeAddressCheckbox = document.querySelector("#id_living_somewhere_else");
  const fieldContainer = document.querySelector(".js-alternative-address");

  const slideDown = () => {
    // We expect the content to be up to 500px high (adjust as needed)
    fieldContainer.classList.add("opacity-100");
    fieldContainer.classList.remove("opacity-0");
    fieldContainer.style.maxHeight = "500px";
  };

  const slideUp = () => {
    fieldContainer.classList.remove("opacity-100");
    fieldContainer.classList.add("opacity-0");
    fieldContainer.style.maxHeight = "0px";
  };

  if (alternativeAddressCheckbox) {
    alternativeAddressCheckbox.addEventListener("change", () => {
      if (alternativeAddressCheckbox.checked) {
        slideDown();
      } else {
        slideUp();
      }
    });
    // Initial state based on checkbox
    if (alternativeAddressCheckbox.checked) {
      slideDown();
    } else {
      slideUp();
    }
  }
  document.querySelectorAll(".password-toggle").forEach(button => {
    button.addEventListener("click", function() {
      const targetId = this.getAttribute("data-target");
      const passwordInput = document.getElementById(targetId);
      const eyeOpen = this.querySelector(".eye-open");
      const eyeClosed = this.querySelector(".eye-closed");

      if (passwordInput.type === "password") {
        passwordInput.type = "text";
        eyeOpen.classList.add("hidden");
        eyeClosed.classList.remove("hidden");
      } else {
        passwordInput.type = "password";
        eyeOpen.classList.remove("hidden");
        eyeClosed.classList.add("hidden");
      }
    });
  });
});



// WEBPACK FOOTER //
// client/masters/start/bundle.js